module.exports = __webpack_public_path__ + "img/zh_cancel.67efa921.png";